import {ActionTypes} from "../contants/Action.Type";
import {safeLocalStorage} from "../../Utils/storage";

const getMostRecent = () => {
  const item = safeLocalStorage.getItem("MostRecent");
  if (!item) return false;
  try {
    return JSON.parse(item);
  } catch {
    return false;
  }
};

const initialState = {
  CurrentCart: [],
  OldCart: [],
  RecentView: getMostRecent(),
  Table: {
    group: [],
    table: [],
  },
};

export const cartReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.CARTDATAOLD:
      return { ...state, OldCart: payload.OldCart };
    case ActionTypes.EMPTY_CURRENT_CART:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.SET_CURRENT_CART:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.DISCOUNT_CURRENT_CART:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.SET_TABLE_DATA:
      return { ...state, Table: payload.Table };
    case ActionTypes.SET_SELECT_DATA:
      return { ...state, Table: payload.Table };
    case ActionTypes.UPDATE_TABLE_DATA:
      return { ...state, Table: payload.Table };
    case ActionTypes.ADD_TO_CART:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.INCREASE_QUANTITY_CART:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.DECREASE_QUANTITY_CART:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.REMOVE_FROM_CART:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.CALCULATE_CART:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.SET_TENDER:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.SET_PAYMENT:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.UPDATE_PAYMENT:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.SET_MEMBERSHIP:
      return { ...state, CurrentCart: payload.CurrentCart };
    case ActionTypes.SET_RECENTLY_ADDED:
      return { ...state, RecentView: payload.RecentView };
    default:
      return state;
  }
};